import { ProductFile } from 'src/pages/UploadPage/Uploader';

/* istanbul ignore next */
export const formatFileUpload = (file: File, name: string, uploadURL: string): ProductFile => ({
  file,
  name,
  uploadState: 'initial',
  presignedUrl: {
    url: uploadURL,
    name,
  },
  products: undefined,
  description: undefined,
  size: file.size,
});
